module.exports = __webpack_public_path__ + "static/media/dep5.a8687bc0.jpg";